import { useTranslation } from "react-i18next";

import { Checkbox, Typography, Box } from "@aviary";
import { l } from "@clinic/emerson/locales/i18n";

interface Props {
  isAccepted?: boolean;
  onCheckboxChange: () => void;
}

const BasicMapAgreement = ({ isAccepted, onCheckboxChange }: Props) => {
  const { t } = useTranslation();

  return (
    <>
      <Typography>{t(l.wholesalePolicies.MAPStandardModalHeaderSubtext)}</Typography>
      <Box isBordered isColor="system">
        <Checkbox checked={isAccepted} onChange={onCheckboxChange}>
          <Typography data-e2e="accept-map-policies-text">
            {t(l.common.AcceptStandardMapPolicies)}
          </Typography>
        </Checkbox>
      </Box>
    </>
  );
};

export { BasicMapAgreement };
